var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "prelative timeline-filters" },
    [
      _c(
        "CompassTabs",
        {
          attrs: { background: "app" },
          on: { input: _vm.handleClick },
          model: {
            value: _vm.selectedTab,
            callback: function($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab"
          }
        },
        _vm._l(_vm.tabList, function(tab, key) {
          return _c("CompassTabPane", {
            key: key,
            attrs: {
              label: tab.label,
              name: tab.value,
              entity: tab.entity,
              icon: _vm.showPinIcon(tab),
              badge: _vm.showTabBadge(tab),
              badgeColor: _vm.badgeColor(tab),
              dataBot: tab.databot
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }